import { render, staticRenderFns } from "./newStore.vue?vue&type=template&id=267daf08&scoped=true&"
import script from "./newStore.vue?vue&type=script&lang=js&"
export * from "./newStore.vue?vue&type=script&lang=js&"
import style0 from "./newStore.vue?vue&type=style&index=0&id=267daf08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267daf08",
  null
  
)

export default component.exports